module.exports = new __parcel__URL__("opsgenie-right.77c52ee2.svg").toString();